import { PERMISSIONS, ROLE_CONFIG_KEYS } from "common/constants";
import useCheckAuthorization from "common/hooks/useCheckAuthorization";
import { Route, Routes } from "react-router-dom";
import AddSCMPO from "./AddSCMPO";
import SCMPurchaseOrderList from "./SCMPurchaseOrderList";
import PODetails from "./PODetails";

const SCMPurchaseOrderManagement = () => {
  useCheckAuthorization({
    config: ROLE_CONFIG_KEYS.scm,
    permission: PERMISSIONS.read
  });

  return (
    <Routes>
      <Route path="add" element = {<AddSCMPO />}/>
      <Route path="/" element={<SCMPurchaseOrderList />} /> 
      <Route path="details/:id" element={<PODetails />}/>
    </Routes>
  );
};

export default SCMPurchaseOrderManagement;
